import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "@fetch/axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useTranslation } from "@hooks/useTranslation";

const ArtistCarousel = () => {

  const [artists, setArtists] = useState([]);
  const [loadingIgImages, setLoadingIgImages] = useState(true);
  const { translate } = useTranslation();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`/artist`);
        // Asegurarse de que la respuesta sea un array
        setArtists(response.data.data);
      } catch (error) {
        console.error("Error fetching Artist posts", error);
        setArtists([]);
      } finally {
        setLoadingIgImages(false);
      }
    };
    fetchPosts();
  }, []);


  const mobileSettings = {
    focusOnSelect: true,
    slidesPerRow: 1,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0",
    swipe: true,
    speed: 300,
    arrows: false,
  };

  const defaultSettings = {
    autoplay: true,
    speed: 1000,
    arrows: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 768,
        settings: mobileSettings,
      },
      {
        breakpoint: 480,
        settings: mobileSettings,
      },
    ],
    afterChange: (current) => {
      let slides = document.querySelectorAll(".ArtistCarousel .slick-slide");
      slides.forEach((slide) => {
        slide.classList.remove("slick-sprev", "slick-snext");
      });

      let activeSlide = document.querySelector(".ArtistCarousel .slick-active");
      if (activeSlide) {
        let prev = activeSlide.previousElementSibling;
        let next = activeSlide.nextElementSibling;
        if (prev) prev.classList.add("slick-sprev");
        if (next) next.classList.add("slick-snext");
      }
    }
  };

  const ArtistItem = ({ image, imagemov, imageButton, link }) => (
    <div className="ArtistItem">
      <Link to={'/'+translate('categories.our_artists_uri') + '/'+link} className="artist-link">
        <picture>
          <source media="(max-width: 768px)" srcSet={imagemov} />
          <img src={image} alt="Banner Artist" className="img-fluid ArtistImage" />
        </picture>
          <div className="ArtistLogoWrap">
            <img
              src={imageButton}
              alt={"Logo del artista"}
              className="ArtistLogo"
              style={{
                width: "auto",
                height: "auto",
                maxWidth: "14rem",
                maxHeight: "6rem",
              }}
            />
          </div>
      </Link>
    </div>
  );

  return (
    <div className="ArtistCarousel">
      <Slider {...defaultSettings}>
        {loadingIgImages ? (
          null
        ) : (
          artists.map((artist, index) => {
              return (
            <ArtistItem
              key={index}
              image={artist.desktop_image}
              imagemov={artist.mobile_image}
              imageButton={artist.button_image}
              link={artist.uri}
            />
              );
            })
        )}
      </Slider>
    </div>
  );
};

export default ArtistCarousel;
